import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@mui/material';

import { PrimaryButton } from '../../../../../../../components/Button/ActionButtons';
import { Spark } from './styles';
import { SummaryScope } from './utils';
import texts from './texts.json';

const trackingButton = {
  [SummaryScope.SELECTION]: 'summarizeSelection',
  [SummaryScope.NOTES]: 'summarizeNotes',
};

const preserveSelection = (event) => {
  event.preventDefault();
};

const SummarizeButton = ({ scope, disabled, onClick }) => {
  const scopeTexts = texts.scope[scope];

  return (
    <Tooltip
      title={disabled ? texts.disabledTooltip : scopeTexts.triggerTooltip}
      placement="top"
      arrow
    >
      <span>
        <PrimaryButton
          type="button"
          size="medium"
          disabled={disabled}
          icon={<Spark>✦</Spark>}
          trackingProps={{ button: trackingButton[scope] }}
          onMouseDown={preserveSelection}
          onClick={onClick}
          $fitToContent
        >
          {scopeTexts.triggerLabel}
        </PrimaryButton>
      </span>
    </Tooltip>
  );
};

SummarizeButton.propTypes = {
  scope: PropTypes.oneOf(Object.values(SummaryScope)).isRequired,
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

SummarizeButton.defaultProps = {
  disabled: false,
};

export default SummarizeButton;
